export enum TicketSearchByEnum {
    OWNER= 0,
    TICKET_NUMBER = 1
}
